import { useMemo, useState, useEffect } from 'react'
import { createAnalytics } from '@holidu/lib/universal/analytics'
import { INTERNAL_V4_URL, INTERNAL_V5_URL } from 'consts/universal'
import {
  selectCurrency,
  selectDomainConfig,
  selectLocale,
  selectUserId,
  selectUuid,
} from 'stores/selectors'

export const useAnalytics = () => {
  const uuid = selectUuid()
  const userId = selectUserId()
  const locale = selectLocale()
  const currency = selectCurrency()
  const domainConfig = selectDomainConfig()
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => setIsMounted(true), [])

  return useMemo(() => {
    if (isMounted) {
      const setupAnalytics = createAnalytics({
        internalV4Url: INTERNAL_V4_URL.replace(
          '{domainId}',
          domainConfig.id.toString(),
        )
          .replace('{locale}', locale)
          .replace('{currency}', currency),
        internalV5Url: INTERNAL_V5_URL.replace(
          '{domainId}',
          domainConfig.id.toString(),
        )
          .replace('{locale}', locale)
          .replace('{currency}', currency),
        googleAnalyticsKey: domainConfig.gaCode,
      })

      return setupAnalytics({
        ga: domainConfig.gaCode,
        userId,
        uuid,
        locale,
        currency,
        isUserSignedIn: false,
        clientVersion: window.appVersion,
        userAgent: window.navigator.userAgent,
      })
    }

    return undefined
  }, [
    isMounted,
    currency,
    domainConfig.gaCode,
    domainConfig.id,
    locale,
    userId,
    uuid,
  ])
}
